import { AbstractControl, ValidationErrors } from '@angular/forms';

export class InputValidators {
  public static noSpacesValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && value.trim() === '') return { required: true };
      return null;
    };
  }

  public static zipCodeValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && value.length != 5) return { zipCode: true };
      return null;
    };
  }
}
